import slugify from "slugify"

/**
 * Extracts plain text content from a heading node's content array
 * Handles nested text nodes and marks
 */
export function extractTextFromHeadingContent(content?: any[]): string {
  if (!content || !Array.isArray(content)) {
    return ""
  }

  let text = ""
  
  for (const node of content) {
    if (node.type === "text" && node.text) {
      text += node.text
    } else if (node.content && Array.isArray(node.content)) {
      // Recursively extract text from nested content
      text += extractTextFromHeadingContent(node.content)
    }
  }
  
  return text.trim()
}

/**
 * Generates a unique anchor ID from heading text content
 */
export function generateAnchorId(text: string): string {
  if (!text.trim()) {
    return "heading"
  }
  
  const slug = slugify(text, {
    lower: true,
    strict: true,
    remove: /[*+~.(),#'"!:@?/]/g,
  })
  
  return `h-${slug}`
}

/**
 * Creates the full anchor URL for a heading
 */
export function createAnchorUrl(headingId: string): string {
  if (typeof window === "undefined") {
    return `#${headingId}`
  }
  
  const url = new URL(window.location.href)
  url.hash = headingId
  return url.toString()
}

